import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import EmptyState from "../components/Elements/EmptyState";
import {
  CloseButton,
  Container,
  Modal,
  ModalContent,
  Wrapper,
} from "../style/view.styles";
import { Sidebar, SidebarContainer } from "../style/sidebar.styles";
import BackButton from "../components/Buttons/BackButton";
import { getLoggedInUser } from "../utils/AuthHandler";
import TalentDetailsBody from "../components/Elements/TalentDetailsBody";
import StartTalentConversation from "../components/Elements/StartTalentConversation";

export default function ConnectWithTalent() {
  const location = useLocation();
  const talentDetails = location.state?.talent;
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [isConnectModalOpen, setIsConnectModalOpen] = useState(false);
  const handleConnectModalClose = () => setIsConnectModalOpen(false);
  const [isTalentContacted, setIsTalentContacted] = useState(false);

  useEffect(() => {
    const user = getLoggedInUser();
    setIsLoggedIn(!!user);
    setUser(user);
  }, []);

  useEffect(() => {
    const user = localStorage.getItem("user");
    setIsLoggedIn(!!user);
  }, []);

  if (!talentDetails) {
    return (
      <>
        <Wrapper>
          <div className="container" style={{ padding: "80px 0" }}>
            <EmptyState message={"Talents soon to come."} />
          </div>
        </Wrapper>
      </>
    );
  }


  const handleModalBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      handleConnectModalClose();
    }
  };

  return (
    <>
      <Wrapper className="paleBlueGreyBg">
        <Container>
          <SidebarContainer>
            <Sidebar>
              <BackButton path="/find-talent" />
            </Sidebar>
          </SidebarContainer>
          <TalentDetailsBody
            talent={talentDetails}
            user={user}
            isLoggedIn={isLoggedIn}
            setIsConnectModalOpen={setIsConnectModalOpen}
            isConnectModalOpen={isConnectModalOpen}
            isTalentContacted={isTalentContacted}
          />
        </Container>
      </Wrapper>
      {isConnectModalOpen && (
        <Modal onClick={handleModalBackgroundClick}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={handleConnectModalClose}>X</CloseButton>
            <StartTalentConversation
              talent={talentDetails}
              onSuccess={() => {
                handleConnectModalClose();
                setIsTalentContacted(true);
              }}
            />
          </ModalContent>
        </Modal>
      )}
    </>
  );
}
